import dayjs from "dayjs";

export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export const formatOrderStatus = (input) => {
    return input
        ?.toLowerCase() 
        ?.split('_') 
        ?.map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        ?.join(' ');
}

export const getUptoFourteenDaysLater = (date) => {
    const fourteenDaysLater = new Date(date);
    fourteenDaysLater.setDate(fourteenDaysLater.getDate() + 14);
    return fourteenDaysLater;
}

export const calculateLocalDeadline = (deadline) => {

    // Extract the number and unit (days or hours) from the deadline string
    const [value, unit] = deadline.split(" ");
    const amount = parseInt(value);

    let newDate;

    if (unit === "days") {
        newDate = dayjs().add(amount, "day");
    } else if (unit === "hours") {
        newDate = dayjs().add(amount, "hour");
    }

    return newDate?.format("YYYY-MM-DD hh:mm A");
}
